// extracted by mini-css-extract-plugin
export default {"item":"ListItem-module__item__V2cwZ"};